<ripple-entity-list
    [entityService]="notificationService"
    [filter]="filter"
    [options]="options"
    [showDeleteButton]="false"
    [customFieldsForFilter]="customFields"
>
</ripple-entity-list>
